import { Helmet } from 'react-helmet-async'

import Container from '../ui/Container'
import SectionHeading from '../ui/SectionHeading'
import ServiceCard from '../ServiceCard'
import { services } from '../../data/site'

function Services() {
  return (
    <>
      <Helmet>
        <title>Our Services | Meditex Healthcare Hub Limited</title>
        <meta
          name="description"
          content="Explore the full range of diagnostic services at Meditex Healthcare Hub Limited: medical health checks, blood banking, chemical pathology, microbiology, endocrinology, virology and parasitology."
        />
      </Helmet>

      <div className="bg-primary py-16">
        <Container>
          <SectionHeading
            eyebrow="What we offer"
            title="Our Diagnostic Services"
            description="Global best-practice laboratory services delivered locally, across a wide range of diagnostic disciplines."
            light
          />
        </Container>
      </div>

      <Container className="py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <ServiceCard key={service.slug} service={service} />
          ))}
        </div>
      </Container>
    </>
  )
}

export default Services
